// src/components/common/ServiceWorkerWrapper.js (NEW FILE)

import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';

const ServiceWorkerWrapper = () => {
  useEffect(() => {
    const onUpdate = (registration) => {
      const waitingServiceWorker = registration.waiting;
      
      if (waitingServiceWorker) {
        const handleUpdate = () => {
          waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        };

        toast.info(
          <div>
            A new version is available!
            <button
              onClick={handleUpdate}
              className="ml-4 px-3 py-1 bg-white text-blue-600 font-semibold rounded"
            >
              Refresh
            </button>
          </div>,
          {
            position: "bottom-center",
            autoClose: false,
            closeOnClick: false,
            draggable: false,
          }
        );
      }
    };

    serviceWorkerRegistration.register({ onUpdate });
  }, []);

  return null; // This component doesn't render anything itself
};

export default ServiceWorkerWrapper;